module.exports = __webpack_public_path__ + "img/boat.cb1977d4.jpg";